module.exports = __webpack_public_path__ + "img/brown-wooden-center-table-584399.3a1900b5.jpg";